var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerFullHeight authBg"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"8","md":"7"}}),_vm._v(" "),_c('b-col',{class:_vm.mobile?'authSectionMobile':'authSection',attrs:{"lg":"4","md":"5"}},[_c('nuxt')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }